import axiosInstance from "@lib/axios";

export const deleteDevice = async (device_id: number): Promise<void> => {
    await axiosInstance.post("/device/delete", { device_id });
};
